const Video = () => {
    const videos = document.querySelectorAll(".js-video");

    if (!videos.length) {
        return false;
    }

    // init iframe api script
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/player_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // on IFrame Player API ready
    window.onYouTubeIframeAPIReady = function () {
        videos.forEach((container) => {
            const toggleEl = container.querySelector(".c-video__toggle");
            const closeEl = container.querySelector(".c-video__close");
            const frameEl = container.querySelector(".c-video__frame");
            const playerEl = container.querySelector(".c-video__player");
            const videoId = container.getAttribute("data-videoId");

            const player = new YT.Player(playerEl, {
                height: "100%",
                width: "100%",
                videoId,
                playerVars: { autoplay: 1, rel: 0, modestbranding: 1 },
                events: {
                    onReady: onPlayerReady,
                    onStateChange: onPlayerStateChange,
                },
            });

            function onPlayerReady(event) {
                // reset the player status, so players don't keep their play state even after reload
                event.target.stopVideo();
            }

            function onPlayerStateChange(event) {
                // video has ended, close the player
                if (event.data === 0) {
                    closeVideo();
                }
            }

            function playVideo() {
                container.classList.add("c-content-block__video--loaded");
                container.classList.add("c-video--loaded");

                frameEl.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });

                // Adds delay to sync with transition
                setTimeout(() => {
                    frameEl.classList.add("c-video__frame--loaded");
                    player.playVideo();
                }, 700);
            }

            function closeVideo() {
                container.classList.remove("c-content-block__video--loaded");
                container.classList.remove("c-video--loaded");
                frameEl.classList.remove("c-video__frame--loaded");

                player.stopVideo();
            }

            toggleEl.addEventListener("click", playVideo);
            closeEl.addEventListener("click", closeVideo);
        });
    };
};

export default Video;
